import { useTranslation } from 'react-i18next';
import { ToggleGroup, ToggleGroupItem } from '@/components/ui/toggle-group';
import { Field } from '../../components/blocks';
import { NumberField } from './shared';

/** The Turnstile setting `challenge_after_failures`: `0` asks on every form, `N` asks a sign-in
 * after N failed attempts (the forms that send an e-mail always ask). */
export const ASK_AFTER_FAILURES = 'challenge_after_failures';

/** How the setting reads in the version in force. */
export function askWhenText(t: (key: string, options?: Record<string, unknown>) => string, value: number): string {
  return value === 0 ? t('captcha.always') : t('captcha.afterFailures', { count: value });
}

/** "Khi nào hỏi": always, or after a number of failed attempts. */
export function AskWhenField({ value, onChange, max }: { value: number | null; onChange: (v: number | null) => void; max?: number }) {
  const { t } = useTranslation('integrations');
  const mode = (value ?? 0) === 0 ? 'always' : 'after';
  return (
    <div className="grid gap-3 sm:col-span-2">
      <Field label={t('provider.field.challenge_after_failures')} group hint={mode === 'always' ? t('captcha.alwaysHint') : t('captcha.afterHint')}>
        <ToggleGroup type="single" variant="outline" size="sm" value={mode} onValueChange={(v) => v && onChange(v === 'always' ? 0 : Math.max(value ?? 0, 3))}>
          <ToggleGroupItem value="always">{t('captcha.always')}</ToggleGroupItem>
          <ToggleGroupItem value="after">{t('captcha.afterChoice')}</ToggleGroupItem>
        </ToggleGroup>
      </Field>
      {mode === 'after' ? <NumberField label={t('captcha.failures')} value={value} onChange={(v) => onChange(v === null ? null : Math.max(v, 1))} min={1} max={max} unit={t('provider.unit.attempts')} /> : null}
    </div>
  );
}
